import { Component } from './component';

export interface TextBoxProps {
  type?: 'text' | 'password' | 'email' | 'number' | 'textarea';
  disabled?: boolean;
  onChange?: (value: string) => void;
  maxLength?: number;
  min?: number;
  max?: number;
}

export class TextBox extends Component {
  public el: HTMLInputElement | HTMLTextAreaElement;

  constructor(props?: TextBoxProps) {
    super();

    if (props?.type === 'textarea') {
      this.el = document.createElement('textarea');
    } else {
      this.el = document.createElement('input');
      this.el.setAttribute('type', props?.type ?? 'text');
    }

    if (props?.maxLength !== undefined) {
      this.el.setAttribute('maxLength', props.maxLength.toString());
    }

    if (props?.type === 'number') {
      if (props.min !== undefined) {
        this.el.setAttribute('min', props.min.toString());
      }
      if (props.max !== undefined) {
        this.el.setAttribute('max', props.max.toString());
      }
    }

    if (props?.disabled) {
      this.el.setAttribute('disabled', 'disabled');
    }

    this.el.addEventListener('input', () => {
      if (props?.onChange) {
        props.onChange(this.el.value);
      }
    });
  }

  getValue(): string {
    return this.el.value;
  }

  setValue(value: string) {
    this.el.value = value;
  }

  disable() {
    this.el.setAttribute('disabled', 'disabled');
  }

  enable() {
    this.el.removeAttribute('disabled');
  }
}
